import {User} from "../../../../../pages/shared/models/user/user";
import BarekamText from "../../../../../pages/components/text";
import {Message, MessageSections} from "../../../../../pages/components/message/message";
import {UserPasswordContainer} from "../../../../../pages/user/settings/personal-info/user-inputs/styled";
import React from "react";
import moment from "moment/moment";
import {BarekamAttachment} from "../../../../../pages/components/attachment/attachment";

const CustomerPersonalInfo = ({customer}: {customer: User | undefined}) => {
    if (customer) {
        return (
            <>
                <UserPasswordContainer>
                    <BarekamText variant={"s"} opaque>
                        <Message messageKey={"user_settings_email"} sectionId={MessageSections.USER}/>
                    </BarekamText>

                    <BarekamText variant={"s"} fontWeight={500}>
                        {customer.email}
                    </BarekamText>
                </UserPasswordContainer>

                <UserPasswordContainer>
                    <BarekamText variant={"s"} opaque>
                        <Message messageKey={"user_first_name"} sectionId={MessageSections.USER}/>
                    </BarekamText>

                    <BarekamText variant={"s"} fontWeight={500}>
                        {customer.firstName}
                    </BarekamText>
                </UserPasswordContainer>

                <UserPasswordContainer>
                    <BarekamText variant={"s"} opaque>
                        <Message messageKey={"user_last_name"} sectionId={MessageSections.USER}/>
                    </BarekamText>

                    <BarekamText variant={"s"} fontWeight={500}>
                        {customer.lastName}
                    </BarekamText>
                </UserPasswordContainer>

                <UserPasswordContainer>
                    <BarekamText variant={"s"} opaque>
                        <Message messageKey={"user_phone"} sectionId={MessageSections.USER}/>
                    </BarekamText>

                    <BarekamText variant={"s"} fontWeight={500}>
                        {customer.phoneNumber}
                    </BarekamText>
                </UserPasswordContainer>

                <UserPasswordContainer>
                    <BarekamText variant={"s"} opaque>
                        <Message messageKey={"user_document_type"} sectionId={MessageSections.USER}/>
                    </BarekamText>

                    <BarekamText variant={"s"} fontWeight={500}>
                        {customer.relatedRecipientId?.documentType
                            ? <Message messageKey={customer.relatedRecipientId.documentType.name} sectionId={MessageSections.USER}/>
                            : '-'
                        }
                    </BarekamText>
                </UserPasswordContainer>

                <UserPasswordContainer>
                    <BarekamText variant={"s"} opaque>
                        <Message messageKey={"user_document_number"} sectionId={MessageSections.USER}/>
                    </BarekamText>

                    <BarekamText variant={"s"} fontWeight={500}>
                        {customer.relatedRecipientId?.passportOrIdSerialNumber || ''}
                    </BarekamText>
                </UserPasswordContainer>

                <UserPasswordContainer>
                    <BarekamText variant={"s"} opaque>
                        <Message messageKey={"user_document_date"} sectionId={MessageSections.USER}/>
                    </BarekamText>

                    <BarekamText variant={"s"} fontWeight={500}>
                        {customer.relatedRecipientId?.documentExpirationDate
                            ? moment(customer.relatedRecipientId?.documentExpirationDate).format('YYYY-MM-DD')
                            : '-'
                        }
                    </BarekamText>
                </UserPasswordContainer>

                <BarekamAttachment titleLabel={<Message messageKey={'passport_photo'} sectionId={MessageSections.USER}/>}
                                   messageSection={MessageSections.USER}
                                   value={customer.relatedRecipientId?.document}
                                   isSingle={true}
                                   isReadonly={true}
                                   onValueChange={() => void(0)}/>
            </>
        )
    } else {
        return <></>
    }
};

export default CustomerPersonalInfo;
